import React from "react"

import ThemeHeader from "../investments/theme-header-container"
import ProjectHeader from "../investments/project-header-container"
import ThemeProjectAdder from "../investments/theme-project-adder"

export default (ppi, shownThemes, priorities, current_year, consulted) => {
	var rows = []
	//var data = []
	var rest = 0
	var index = 0
	ppi.investment_themes.map(investment_theme => {
		//if (!this.props.asResponsible || investment_theme.responsible.id == this.props.currentUser.id) {
			rows.push({
				title: investment_theme.name,
				theme: investment_theme,
				item: investment_theme,
				isShown:  (shownThemes.indexOf(investment_theme.id) !== -1),
				cellComponents: [{
					index: 0,
					component: ThemeHeader
				}],
				index,
				cellProps: {
					format  : "0,0",
					language: "fr-FR",
					type    : "numeric",
					mantissa: 0
				},
				consulted: consulted,
				className: "invest-theme",
				readOnly: true
			})

			//data.push(_reduceThemeProjectAmounts(investment_theme, ppi, current_year, priorities))
			//data[index].unshift(investment_theme.name)

			index++

			//if (shownThemes.indexOf(investment_theme.id) !== -1) {
				investment_theme.themes.map(subtheme => {
					rows.push({
						title: subtheme.name,
						theme: investment_theme,
						subtheme,
						item: subtheme,
						isSubTheme: true,
						isShown:  (shownThemes.indexOf(subtheme.id) !== -1),
						cellComponents: [{
							index: 0,
							component: ThemeHeader
						}],
						consulted: consulted,
						index,
						cellProps: {
							format  : "0,0",
							language: "fr-FR",
							type    : "numeric",
							mantissa: 0
						},
						className: "invest-subtheme",
						readOnly: true
					})

					//data.push(_reduceSubThemeProjectAmounts(subtheme, ppi, current_year, priorities))
					//data[index].unshift(subtheme.name)

					index++

					//if (shownThemes.indexOf(subtheme.id) !== -1) {
						subtheme.projects.map(project => {
							if (priorities.length == 0 || priorities.indexOf(project.priority) !== -1) {

								rest = 0
								project.years.map(y => {
									rest += (y.amount ? y.amount : 0)
								})
								rest = project.budget - rest
								project.grants.map(grant => {
									grant.years.map(year => { rest += year.amount ? year.amount : 0	})
									rest -= grant.budget
								})

								rows.push({
									title: project.name,
									project,
									theme: investment_theme,
									isBalanced: (rest === 0),
									subtheme: subtheme,
									isSubProject: true,
									cellComponents: [{
										index: 0,
										component: ProjectHeader
									}],
									consulted: consulted,
									index,
									cellProps: {
										format  : "0,0",
										language: "fr-FR",
										type    : "numeric",
										mantissa: 0
									},
									className: "invest-project" + (project.visible ? "" : " project-disabled"),
									readOnly: true
								})

								//data.push(project.years.filter(y => (y.year >= current_year)).map(y => y.amount))
								//data[index].unshift(project.name)

								index++
							}
						})

					//}
				})

				investment_theme.projects.map(project => {
					if (priorities.length == 0 || priorities.indexOf(project.priority) !== -1) {
						rest = 0
						project.years.map(y => {
							rest += (y.amount ? y.amount : 0)
						})
						rest = project.budget - rest
						project.grants.map(grant => {
							grant.years.map(year => { rest += year.amount ? year.amount : 0	})
							rest -= grant.budget
						})

						rows.push({
							title: project.name,
							project,
							theme: investment_theme,
							isBalanced: (rest === 0),
							cellComponents: [{
								index: 0,
								component: ProjectHeader
							}],
							consulted: consulted,
							index,
							cellProps: {
								format  : "0,0",
								language: "fr-FR",
								type    : "numeric",
								mantissa: 0
							},
							className: "invest-project" + (project.visible ? "" : " project-disabled"),
							readOnly: true
						})

						//data.push(project.years.filter(y => (y.year >= current_year)).map(y => y.amount))
						//data[index].unshift(project.name)

						index++
					}
				})

			//}
		//}
	})

	return rows

}

export const reduceThemeProjectAmounts = (theme, ppi, current_year, priorities) => {
	return ppi.years.filter(y => (y.year >= current_year)).map(y => {
		var amount = reduceSubThemeProjectAmount(y, theme, priorities)
		theme.themes.map(t => {
			amount += reduceSubThemeProjectAmount(y, t, priorities)
		})
		return amount
	})
}

const reduceSubThemeProjectAmount = (year, theme, priorities) => {
	var r = 0
	theme.projects.map(p => {
		if (p.visible && (priorities.length == 0 || priorities.indexOf(p.priority) !== -1)) {
			r += p.years.find(y => y.year == year.year).amount
		}
	})
	return r
}

// const _reduceSubThemeProjectAmounts = (subtheme, ppi, current_year, priorities) => {
// 	return ppi.years.filter(y => (y.year >= current_year)).map(y => (
// 		reduceSubThemeProjectAmount(y, subtheme, priorities)
// 	))
// }



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/utils/investments-helper.js